import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-container">
        {/* Company & Platform Branding */}
        <div className="footer-brand">
          <div className="brand-header">
            <span className="brand-icon">🎓</span>
            <span className="brand-name">Venus Software Academy</span>
          </div>
          <p className="brand-description">
            Empowering educational institutions with enterprise-grade ERP solutions, dynamic analytics, and seamless administration tools.
          </p>
          <a 
            href="https://venuslearn.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="domain-link"
          >
            🌐 venuslearn.com
          </a>
        </div>

        {/* Quick Navigation Links */}
        <div className="footer-links-group">
          <h4>Platform Portals</h4>
          <ul>
            <li><Link to="/login">Portal Login</Link></li>
            <li><Link to="/admin/dashboard">Admin Dashboard</Link></li>
            <li><Link to="/teacher/dashboard">Teacher Hub</Link></li>
            <li><Link to="/student/dashboard">Student Portal</Link></li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-contact">
          <h4>Get in Touch</h4>
          <ul className="contact-list">
            <li>
              <span className="contact-icon">📧</span>
              <a href="mailto:info@venuslearn.com">info@venuslearn.com</a>
            </li>
            <li>
              <span className="contact-icon">📞</span>
              <a href="tel:+251940651252">+251 940 651 252</a>
            </li>
            <li>
              <span className="contact-icon">🌍</span>
              <a href="https://venuslearn.com" target="_blank" rel="noopener noreferrer">www.venuslearn.com</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>Powered by <strong>Venus Software Academy</strong></p>
          <p className="copyright">&copy; {currentYear} Venus Software Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
